import React from 'react'
import { Text } from '@chilipiper/design-system'
import { rolloutFlags } from '@chilipiper/rollout'

export const ConsentFooter = () => {
  return (
    <Text
      as='a'
      target='_blank'
      href={rolloutFlags.chatConsentFooterLink?.getValue().toString()}
      color='fg/moderate'
      textAlign='center'
      fontSize={10}
      fontWeight={500}
      display='block'
    >
      {rolloutFlags.chatConsentFooter?.getValue()}
    </Text>
  )
}
